import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Mail, X, RefreshCw, CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

export default function EmailVerificationBanner() {
  const { user, isEmailVerified, resendVerificationEmail } = useAuth();
  const [isResending, setIsResending] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  // Don't show if verified or dismissed
  if (isEmailVerified || isDismissed || !user) return null;

  const handleResend = async () => {
    setIsResending(true);
    const result = await resendVerificationEmail();
    setIsResending(false);

    if (result.success) {
      toast.success("E-mail reenviado! Confere lá (inclusive o spam, vai que o porquinho foi parar lá).");
    } else {
      toast.error(result.error || "Ops! Tenta de novo em alguns minutos.");
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        className="bg-gradient-to-r from-amber-400 to-orange-500 text-white px-4 py-3 shadow-lg"
        data-testid="email-verification-banner"
      >
        <div className="max-w-lg mx-auto flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
              <Mail className="w-4 h-4" />
            </div>
            <div className="text-sm">
              <p className="font-bold">Verifique seu e-mail!</p>
              <p className="text-white/90 text-xs">
                Enviamos um link de confirmação. Sem isso, o porquinho fica triste.
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <Button
              size="sm"
              variant="ghost"
              className="text-white hover:bg-white/20 h-8 px-3 text-xs font-bold"
              onClick={handleResend}
              disabled={isResending}
              data-testid="resend-verification-btn"
            >
              {isResending ? (
                <RefreshCw className="w-4 h-4 animate-spin" />
              ) : (
                "Reenviar"
              )}
            </Button>
            <Button
              size="sm"
              variant="ghost"
              className="text-white hover:bg-white/20 h-8 w-8 p-0"
              onClick={() => setIsDismissed(true)}
              data-testid="dismiss-verification-btn"
            >
              <X className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
